module.exports = __webpack_public_path__ + "static/img/genomics_clusters_5.9b93a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/genomics_clusters_5.png
// module id = U2Tx
// module chunks = 6